



































import { Component, Vue } from 'vue-property-decorator';
import { mdbIcon } from '@folky-tools/mdbvue';

@Component({
    components: {
        mdbFooter: () => import('@folky-tools/mdbvue/src/components/Navigation/Footer.vue'),
        mdbContainer: () => import('@folky-tools/mdbvue/src/components/Layout/Container.vue'),
        mdbRow: () => import('@folky-tools/mdbvue/src/components/Layout/Row.vue'),
        mdbCol: () => import('@folky-tools/mdbvue/src/components/Layout/Col.vue'),
        LanguageSelector: () => import('@/components/shared/LanguageSelector.vue'),
        mdbIcon
    }
})
export default class FooterPanel extends Vue {
    private get appVersion(): string {
        return '37.0.49';
    }
}
